// extracted by mini-css-extract-plugin
export default {"root":"overbookings_management_modal-module___root___b2d76421","divider":"overbookings_management_modal-module___divider___b21fac13"};